import React from 'react';

export function SuggestedTag() {
  return (
    <span className="ml-2 inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-semibold text-blue-700">
      Suggested
    </span>
  );
}

export function SuggestedField({
  label,
  suggested = false,
  required = false,
  error,
  children,
}) {
  return (
    <div>
      <label className="block text-sm font-semibold text-slate-700 mb-1">
        {label}
        {required ? ' *' : ''}
        {suggested ? <SuggestedTag /> : null}
      </label>
      <div
        className={
          error
            ? '[&_input]:border-red-500 [&_input]:ring-1 [&_input]:ring-red-300 [&_select]:border-red-500'
            : suggested
              ? '[&_input]:border-blue-300 [&_input]:bg-blue-50/40 [&_select]:border-blue-300 [&_select]:bg-blue-50/40'
              : ''
        }
      >
        {children}
      </div>
      {error ? <p className="text-xs text-red-600 mt-1">{error}</p> : null}
    </div>
  );
}
